import React from "react"
import { StyledIcon } from "../StyledIcon"

// eslint-disable-next-line import/prefer-default-export
const EllipseWmoIcon = ({ icon, size }) => (
  <StyledIcon
    viewBox="0 0 56 57"
    fill="none"
    a11yTitle={icon}
    color="plain"
    size={size}
  >
    <circle cx="28" cy="28.5562" r="26" stroke="#FFCD05" stroke-width="4" />
  </StyledIcon>
)

export default EllipseWmoIcon
